import {isNullOrUndefined} from "../../../../services/Validator";

export default function ExerciserCorrectionAppreciationText({isCorrect}) {
    // Used in ExerciserCorrectionUserAnswer to display appreciation
    // message based on userAnswer isCorrect statement

    // BUILD
    if (isNullOrUndefined(isCorrect))
        return null
    return (
        <div className={"mt-[8px] w-full flex justify-center items-center font-medium"}>
            <span className={`${isCorrect ? "text-primaryLight1" : "text-secondaryLight1"}`}>
                {isCorrect ? "Tu as trouvé la bonne réponse" : "Tu as fait une erreur"}
            </span>
        </div>
    )
}